<template>
    <div class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <p class="payment-loader-msg" v-if="paymentInitiateLoader">Payment Processing...</p>
        <p class="payment-notify-msg" v-if="paymentInitiateLoader">Do not close or refresh this page</p>
    </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'loader',
    computed: {
      ...mapGetters({
        paymentInitiateLoader: 'paymentInitiateLoader'
      })
    }
  }
</script>

<style scoped>
  .lds-ring {
    width: 64px;
    height: 500px;
    margin: 0 auto;
    padding: 100px 0;
  }

  .payment-loader-msg {
    margin: 100px 0 0 -45px;
    color: #808080;
    width: 200px;
    font-size: larger;
    font-weight: 600;
  }

  .payment-notify-msg {
    margin: 0px 0 0 -60px;
    color: #dc2a2a;
    width: 300px;
    font-weight: 400;
  }

  .lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 51px;
    height: 51px;
    margin: 6px;
    border: 6px solid #808080;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #808080 transparent transparent transparent;
  }

  .lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
  }

  .lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
  }

  .lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
  }

  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// loader.vue?27f55e3e